//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { MapLayerGroupType } from '../Shared/Models/MapConfigModels';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { TableInLineEdits } from '../Shared/Utility/TableInLineEdits';
import { Feature } from 'ol';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',

    legalEventsEditPathAffectedPrintBtn = '#legalEventsEditPathAffectedPrintBtn',
    legalEventsEditPathAffectedAddBtn = '#legalEventsEditPathAffectedAddBtn',
    legalEventsEditPathAffectedEditBtn = '#legalEventsEditPathAffectedEditBtn',
    legalEventsEditPathAffectedDeleteBtn = '#legalEventsEditPathAffectedDeleteBtn',
    legalEventsEditModal = '#legalEventsEditModal',
    legalEventsEdit_PathsAffectedAddModal = '#legalEventsEdit_PathsAffectedAddModal',
    legalEventsEdit_PathsAffectedAddSubmitBtn = '#legalEventsEdit_PathsAffectedAddSubmitBtn',
    legalEventsEdit_PathsAffectedAddCloseBtn = '#legalEventsEdit_PathsAffectedAddCloseBtn',
    legalEventsEdit_PathsAffectedAddCancelBtn = '#legalEventsEdit_PathsAffectedAddCancelBtn',
    legalEventsEdit_PathsAffectedAddForm_singlePathList = '#legalEventsEdit_PathsAffectedAddForm_singlePathList',

    legalEventsEdit_PathsAffectedEditModal = '#legalEventsEdit_PathsAffectedEditModal',
    legalEventsEdit_PathsAffectedEditCloseBtn = '#legalEventsEdit_PathsAffectedEditCloseBtn',
    legalEventsEdit_PathsAffectedEditCancelBtn = '#legalEventsEdit_PathsAffectedEditCancelBtn',
    legalEventsEdit_PathsAffectedEditSubmitBtn = '#legalEventsEdit_PathsAffectedEditSubmitBtn',
    legalEventsEdit_PathsAffectedEditForm = '#legalEventsEdit_PathsAffectedEditForm',
    AffectedPathsTreeResults = '#AffectedPathsTreeResults',

    addPathLegalWizardPanel = '#addPathLegalWizardPanel',
    addPathLegalWizardCloseBtn = '#addPathLegalWizardCloseBtn',
    addPathLegalWizard_CancelBtn = '#addPathLegalWizard_CancelBtn',
    addPathLegalWizard_SaveBtn = '#addPathLegalWizard_SaveBtn'
}

export class LegalEvents_AffectedPaths {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private selectedRecordList: Array<string> = [];
    private selectedMapList: Array<string> = [];
    private legalRouteInlineEdits: Array<{ LegalRouteID: String, Effect: String}> = [];
    private newAddAffectedPathWizardState: { legalCode?: string, featureSelectedCAMSKey?: ICAMSKey };
    private subscriptionSingleFeatureSelected;
    private treeView: any;

    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: null, enable: false },
        new: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        const self = this;
        Utilities.GetControl(jqc.addPathLegalWizard_SaveBtn).on('click', function () { self.addAffectedPathWizard_Save() });
        Utilities.GetControl(jqc.addPathLegalWizard_CancelBtn).on('click', function () { self.addAffectedPathWizard_Cancel() });
        Utilities.GetControl(jqc.addPathLegalWizardCloseBtn).on('click', function () { self.addAffectedPathWizard_Close() });
    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize btns
        self.actionBtns = {
            viewprint: { btn: $(jqc.legalEventsEditPathAffectedPrintBtn+' button'), enable: false },
            new: {
                btn: $(jqc.legalEventsEditPathAffectedAddBtn +' button'), enable: false },
            edit: {
                btn: $(jqc.legalEventsEditPathAffectedEditBtn +' button'), enable: false },
            delete: {
                btn: $(jqc.legalEventsEditPathAffectedDeleteBtn +' button'), enable: false }
        };

        self.actionBtns.viewprint.btn.on('click', function () { toastr.info('To be completed'); });
        self.actionBtns.new.btn.on('click', function () { self.addAffectedPathWizard_Start(data.code); });
        self.actionBtns.edit.btn.on('click', function () { let nodes: Array<INode> = self.treeView.treeview('getSelected'); self.openEditPanel(nodes[0].href, data.code); });
        self.actionBtns.delete.btn.on('click', function () { self.deletePaths(data); });

        // Reset the inline edit object
        self.legalRouteInlineEdits = [];

        // Get Route data
        self.GetTreeData(data);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
   
    public openAddPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();
        
        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Legal/LegalEventsEdit_PathsAffectedAddView', function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedAddModal, ModalAction.Create);

            // Get selected map and record list data
            $(jqc.legalEventsEdit_PathsAffectedAddModal + ' [name="singlePathList_Input"]').on('keyup', function () { self.getPathsFromTypeAhead();} );
            self.GetDataFromRecordList();
            self.GetDataFromMapSelect();

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedAddSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Get a list of all the paths selected
                let listOfPaths: Array<string> = [];
                if ($(jqc.legalEventsEdit_PathsAffectedAddModal+' [name="singlePathList_Check"]').is(':checked').toString() == "true") {
                    listOfPaths.push($(jqc.legalEventsEdit_PathsAffectedAddModal +' [name="singlePathList_Input"]').val().toString());
                }
                if ($(jqc.legalEventsEdit_PathsAffectedAddModal +' [name="selectInList_Check"]').is(':checked').toString() == "true") {
                    listOfPaths = listOfPaths.concat(self.selectedRecordList);
                }
                if ($(jqc.legalEventsEdit_PathsAffectedAddModal +' [name="selectOnMap_Check"]').is(':checked').toString() == "true") {
                    listOfPaths = listOfPaths.concat(self.selectedMapList);
                }

                if (listOfPaths.length == 0) {
                    toastr.info("Please select at least one item before adding");
                    return;
                }

                if (listOfPaths.length == 0) {
                    toastr.error("Please select at least one check box item!");
                    return;
                }

                Utilities.BlockUI($(jqc.legalEventsEdit_PathsAffectedAddModal + " .modal-content"));
                $.post('/Legal/AddRoutesToLegalEvent', { legalCode: data.code, listOfPaths: listOfPaths },
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Added routes!')
                                self.GetTreeData(data);
                                Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedAddModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                            }
                            else {
                                toastr.error('Failed to add routes!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($(jqc.legalEventsEdit_PathsAffectedAddModal + " .modal-content"));
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedAddCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedAddCancelBtn).on('click', function (evt) {;
                Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });
           
        });
    }

    public openEditPanel = (legalRouteID: string, legalCode: string): void => {
        const self = this;
        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();

        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Legal/LegalEventsEdit_PathsAffectedEditView', { legalRouteID: legalRouteID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedEditModal, ModalAction.Create);

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedEditSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                let form: any = Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedEditForm);
                if (Utilities.CheckFormValidation(form) == false) return;
      
                // Update legal route
                self.legalRouteInlineEdits = [];
                self.legalRouteInlineEdits.push({
                    LegalRouteID: (form.find('[name="LegalRouteID"]').val()) as any,
                    Effect: (form.find('[name="Effect"]').val()) as any
                });
                self.UpdateLegalRouteData(function (r) {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedEditModal));
                    if (r == true) {
                        Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedEditModal, ModalAction.Hide);
                        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                        events.bus.publish(events.eventOpenLegalEventsEditPanel({ code: legalCode , featureType: FeatureType.LegalEvent}));
                    }
                });
            });

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedEditCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedEditModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });

            Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedEditCancelBtn).on('click', function (evt) {
                ;
                Utilities.GetModal(jqc.legalEventsEdit_PathsAffectedEditModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
            });

        });
    }

    public deletePaths = (data: ICAMSKey): void => {
        const self = this;
        let nodes: Array<INode> = self.treeView.treeview('getSelected');
        let legalRouteIDs = [];
        nodes.forEach(r => {
            legalRouteIDs.push(r.href);
        });

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                deleteNow();
            }
            else {
            }
        }).catch(e => { });

        function deleteNow() {
            Utilities.BlockUI();
            $.post('/Legal/DeleteLegalRoutes', { legalRouteIDs: legalRouteIDs },
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            self.GetTreeData(data)
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        Utilities.UnBlockUI();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    public UpdateLegalRouteData = (callback: Function): void => {
        const self = this;

        // Only update if there have been inline edits
        if (self.legalRouteInlineEdits.length == 0) return;

        let url = "/Legal/UpdateLegalRoutes";
        let query = { data: self.legalRouteInlineEdits };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info("Updated route data!")
                        if (callback != null) callback(true);
                    }
                    else {
                        if (callback != null) callback(false);
                    }
                }
                catch (err) {
                    console.log(err);
                    if (callback != null) callback(false);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetDataFromRecordList = (): void => {
        const self = this;
        events.bus.publish(events.eventGetRecordSelectRecords(function (data: Array<INode>) {
            self.selectedRecordList = [];
            data.forEach(d => { if (d.featureType == FeatureType.Route) self.selectedRecordList.push(d.href); } );
            let el = $(jqc.legalEventsEdit_PathsAffectedAddModal+' [name="selectInList"]');
            if (self.selectedRecordList.length == 0) {
                el.val("No records selected");
            }
            else {
                let s = ""; if (self.selectedRecordList.length > 0) s = "s";
                el.val(self.selectedRecordList.length + " record"+s+" selected");
            }

            //el.find('option').remove().end();

            //if (data == null || data.length == 0) {
            //    el.append($("<option></option>").attr("value", null).html("No records selected"));
            //}
            //data.forEach(i => {
            //    if (i.featureType == FeatureType.Route) {
            //        el.append($("<option></option>").attr("value", i.href).html(i.text));
            //    }
            //});

        }));
    }

    private GetDataFromMapSelect = (): void => {
        const self = this;
        events.bus.publish(events.eventGetMapSelectRecords(function (data: Array<INode>) {
            self.selectedMapList = [];
            data.forEach(d => { if (d.featureType == FeatureType.Route) self.selectedMapList.push(d.href); } );
            let el = $(jqc.legalEventsEdit_PathsAffectedAddModal+' [name="selectOnMap"]');
            if (self.selectedMapList.length == 0) {
                el.val("No records selected");
            }
            else {
                let s = ""; if (self.selectedMapList.length > 0) s = "s";
                el.val(self.selectedMapList.length + " record" + s + " selected");
            }
        }));
    }

    // ----------------------------------------------------------- //
    // Add new affected path WIZARD
    public addAffectedPathWizard_Start = (legalCode: string): void => {
        const self = this;

        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.addPathLegalWizard_SaveBtn).hide();
        Utilities.GetControl(jqc.addPathLegalWizardPanel).addClass('show');

        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Route, true]));

        // Reset everything
        this.newAddAffectedPathWizardState = { legalCode: legalCode };
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        // START: If a feature is provided then skip step 1, otherwise do step 1
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route] };
        events.bus.publish(events.eventStartSingleSelection(interactionData))

        // STEP 1: Select Geom
        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            self.subscriptionSingleFeatureSelected();
            var data: ICAMSKey = {};
            let props = m.payload.getProperties();
            if (props.RouteCode != null) {
                data.featureType = FeatureType.Route;
                data.code = props.RouteCode;
            }

            self.newAddAffectedPathWizardState.featureSelectedCAMSKey = data;
            Utilities.GetControl(jqc.addPathLegalWizard_SaveBtn).show();
        });

        // Zoom to existing rows
        //var table: any = Utilities.GetControl(jqc.legalEventsEditPathAffectedTable);
        //let wkts = table.bootstrapTable('getData').map(m => m.WKT);
        //events.bus.publish(events.eventZoomToWKTandHighlight([wkts, true, true, FeatureType.LegalEvent]));
    }

    private addAffectedPathWizard_Save = (): void => {
        const self = this;
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();

        let data: ICAMSKey = this.newAddAffectedPathWizardState.featureSelectedCAMSKey;

        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();
        $.post('/Legal/AddRoutesToLegalEvent', { legalCode: self.newAddAffectedPathWizardState.legalCode, listOfPaths: [data.code] },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info('Added route!')
                        self.GetTreeData({ code: self.newAddAffectedPathWizardState.legalCode, featureType: FeatureType.LegalEvent });

                        Utilities.GetModal(jqc.addPathLegalWizardPanel, ModalAction.Hide);
                        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                        Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                    }
                    else {
                        toastr.error('Failed to add routes!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI();
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private addAffectedPathWizard_Close = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
    }

    private addAffectedPathWizard_Cancel = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
    }

    // ----------------------------------------------------------- //
    // MISC
    private checkVisibleButtons = (): void => {
        const self = this;
        let nodes: Array<INode> = self.treeView.treeview('getSelected');
        //let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (nodes && nodes.length == 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
        }
        else if (nodes && nodes.length > 1) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.delete.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private getPathsFromTypeAhead = (): void => {
        // Check if min length is entered
        let inputCtrl = $(jqc.legalEventsEdit_PathsAffectedAddModal + ' [name="singlePathList_Input"]');
        let listCtrl = Utilities.GetControl(jqc.legalEventsEdit_PathsAffectedAddForm_singlePathList);
        var searchStr = inputCtrl.val().toString();

        // Only get data for exactly 3 chars entered
        if (searchStr == null || searchStr.length < 3) {
            listCtrl.find('option').remove().end();
        }
        // If there is exactly 3 chars OR the list is close to the max length, then search again
        //else if (searchStr.length == 3 || listCtrl.children().length >5) {
        else if (searchStr.length >= 3) {
            // Disable control
            //inputCtrl.prop('disabled', true);
            //inputCtrl.prop('readonly', true);

            // Get List of paths
            let url = '/Route/GetRouteCodeList';
            let query = { searchStr: searchStr };
            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            // Delete existing paths
                            listCtrl.find('option').remove().end();

                            // Add paths to the list
                            result.data.forEach(i => {
                                listCtrl.append($("<option></option>").attr("value", i).text(i));
                            });
                        }
                        else {
                            toastr.error("Failed to get path data.")
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        // Reneable ctrl
                        //inputCtrl.prop('disabled', false);
                        //inputCtrl.prop('readonly', false);
                        //inputCtrl.focus();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // GET DATA FROM SERVER
    private GetTreeData = (data: ICAMSKey): void => {        
        const self = this;
        let query = { legalCode: data.code };
        let url = "/Legal/GetTreeDataForPathsAffected";
        $.post(url, query,
            function (result: IAPIResult) {               
                try {
                    if (result.success == true) {
                        var data = result.data.nodes as Array<INode>;
                        self.createTree(data, true);
                        self.checkVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#AffectedPathsTreeResults');
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: false,
            multiSelect: false,
            onNodeSelected: function (event, node) {
                self.checkVisibleButtons();
            },
            onNodeUnselected: function (event, node: INode) {
                self.checkVisibleButtons();
            },
            onNodeChecked: function (event, node) {

            },
            onNodeUnchecked: function (event, node) {

            },
            onMapBtnClicked: function (event, node) {
                // Get the correct node instance from the tree and then fire the nodeSelected event
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = true; // temp set this to stop the edit form being opened
                self.treeView.treeview('selectNode', [nodeA, { silent: false }]);
                // ****************************************************************************** //

                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, node.featureType]));
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                }
                else {
                    toastr.info('The record has no associated map feature')
                }

            },

            onLSTreeEventClicked: function (event, node, el) {
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                var routeCode = $(el).data('routecode');
                if (routeCode != null) events.bus.publish(events.eventOpenRouteEditPanel({ code: routeCode, featureType: FeatureType.Route }));
                else {
                    var pathCode = $(el).data('pathcode');
                    if (pathCode != null) events.bus.publish(events.eventOpenPathEditPanel({ code: pathCode, featureType: FeatureType.Path }));

                }
            }
        });

        // Start collapsed
        this.treeView.treeview('collapseAll', { silent: true });

        // Create the tree header       
        self.treeView.treeview('addHeader', {

            cols: [{ label: "Code", value: "test1", size: 2 },
            { label: "Staus", value: "test2", size: 2 },
            { label: "Legal", value: "test3", size: 2 },
            { label: "Effect", value: "test4", size: 5 },
            { label: "Map", value: "test5", size: 1 }]

        });
    }

    // ----------------------------------------------------------- //
   
}




